import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-833d5ca6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "school-run-box header-top"
};
const _hoisted_2 = {
  class: "school-run-box-content"
};
const _hoisted_3 = {
  class: "content-3-box common-flex-direction-center"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title"
}, "迪想校园平台下载", -1));

const _hoisted_5 = {
  class: "content-3-box-tab-box"
};
const _hoisted_6 = ["onMouseover"];
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  key: 0,
  class: "content-item-box"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "item-right-box"
};
const _hoisted_11 = {
  class: "title wow bounceInDown"
};
const _hoisted_12 = {
  class: "des wow bounceInRight"
};
const _hoisted_13 = {
  class: "qrcode-text wow slideInUp"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "code-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 7,
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content3Tab, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", $data.content3ActiveIndex == index ? 'active' : '']),
      key: index,
      onMouseover: $event => $options.mouseoverTab(index)
    }, _toDisplayString(item), 43, _hoisted_6);
  }), 128))]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content3List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item",
      key: index
    }, [$data.content3ActiveIndex == index ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
      class: "wow slideInLeft item-image",
      src: item.image
    }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(item.des), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      class: "qrcode",
      src: item.qrcode,
      alt: ""
    }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString(item.codeText), 1)])])])) : _createCommentVNode("", true)]);
  }), 128))])])]), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"])]);
}